import {
  CHANGELOG_FETCH_LOAD,
  CHANGELOG_FETCH_SUCCEED,
  CHANGELOG_FETCH_FAIL,
  CHANGELOG_FETCH_DETAIL_LOAD,
  CHANGELOG_FETCH_DETAIL_SUCCEED,
  CHANGELOG_FETCH_DETAIL_FAIL,
} from '../constants/actionTypes'

const initialState = {
  isLoading: false,
  error: null,
  data: [],
  total: 0,
  skip: 0,
  limit: 20,
  detail: null,
  isDetailLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGELOG_FETCH_LOAD:
      return { ...state, isLoading: true, error: null }
    case CHANGELOG_FETCH_SUCCEED:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        total: action.total,
        skip: action.skip,
        limit: action.limit,
      }
    case CHANGELOG_FETCH_FAIL:
      return { ...state, isLoading: false, error: action.error }
    case CHANGELOG_FETCH_DETAIL_LOAD:
      return { ...state, isDetailLoading: true, error: null }
    case CHANGELOG_FETCH_DETAIL_SUCCEED:
      return { ...state, isDetailLoading: false, detail: action.detail }
    case CHANGELOG_FETCH_DETAIL_FAIL:
      return { ...state, isDetailLoading: false, error: action.error }
    default:
      return state
  }
}

